<template>
  <div class="text-entry-component question-type-component">
    <div class="hint-text" v-if="$props.question.hint">{{ $props.question.hint.get() }}</div>
    <div class="input-field-wrapper">
      <template v-for="(option, i) in $props.question.options">
        <CheckboxComponent @click="onCheckbox(i)" v-model="checkboxModels[i]" v-if="option.display === 'checkbox'" :label="option.name.get()" :value="option.name.get()" />
        <TextfieldComponent v-else v-model="submission['root'][`${option.value}`]" :label="option.name.get()" />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import QualityMentoringFormQuestion from '../../models/QualityMentoringFormQuestion';
import CheckboxComponent from '../../../../frontendkit/components/CheckboxComponent.vue';
import { onMounted, reactive, ref } from 'vue';

const emit = defineEmits(['checkboxInput'])

const props = defineProps({
  question: QualityMentoringFormQuestion,
  submission: Object
})

function clear() {
  props.question.options.forEach((option) => {
    delete props.submission['root'][option.value];
  })
}

defineExpose({
  clear
})

const checkboxModels = reactive(props.question.options.map((option) => {
  return !!props.submission['root'][option.value];
}));

const onCheckbox = (index) => {
  const option = props.question.options[index];
  const value = checkboxModels[index];
  if(value) {
    props.submission.root[option.value] = option.name['en'];
  }
  else {
    delete props.submission.root[option.value];
  }
  emit('checkboxInput');
}

</script>
